import styled from 'styled-components';

export interface IContainerProps {
  background: string;
  shadow?: string;
  notActive?: boolean;
}
export const Container = styled.div<IContainerProps>`
  width: 300px;
  min-height: 55px;
  position: relative;
  overflow: hidden;
  padding: 10px;
  border-radius: 10px;
  user-select: none;
  margin-top: 20px;
  display: flex;
  gap: 10px;

  background: ${({ background }) => background};
  box-shadow: ${(props) => props.shadow};

  & svg {
    color: ${({ background }) => background};
  }

  animation: ${({ notActive }) => (notActive ? 'slide-out-toast' : 'slide-in-toast')} 0.6s
    cubic-bezier(0.23, 1, 0.32, 1) both;

  @keyframes slide-in-toast {
    0% {
      -webkit-transform: translateX(1000px) scaleX(2.5) scaleY(0.2);
      transform: translateX(1000px) scaleX(2.5) scaleY(0.2);
      -webkit-transform-origin: 0% 50%;
      transform-origin: 0% 50%;
      -webkit-filter: blur(40px);
      filter: blur(40px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0) scaleY(1) scaleX(1);
      transform: translateX(0) scaleY(1) scaleX(1);
      -webkit-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
      -webkit-filter: blur(0);
      filter: blur(0);
      opacity: 1;
    }
  }
  @keyframes slide-out-toast {
    0% {
      -webkit-transform: translateX(0) scaleY(1) scaleX(1);
      transform: translateX(0) scaleY(1) scaleX(1);
      -webkit-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
      -webkit-filter: blur(0);
      filter: blur(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateX(1000px) scaleX(2) scaleY(0.2);
      transform: translateX(1000px) scaleX(2) scaleY(0.2);
      -webkit-transform-origin: 0% 50%;
      transform-origin: 0% 50%;
      -webkit-filter: blur(40px);
      filter: blur(40px);
      opacity: 0;
    }
  }
`;

export const IconContainer = styled.div`
  display: flex;
  min-height: 40px;
  max-height: 40px;
  min-width: 40px;
  max-width: 40px;
  border-radius: 8px;
  background: white;
  align-items: center;
  justify-content: center;

  & svg {
    width: 22px;
    height: 22px;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  position: relative;
`;

export const ProgressBar = styled.div`
  background-color: white;
  height: 3px;
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0.7;
  border-radius: 3px;
`;

export const Message = styled.p`
  font-size: 12px;
  color: white;
  word-wrap: break-word;
  word-break: break-all;
`;

export const CloseBtn = styled.button`
  min-width: 20px;
  min-height: 20px;
  max-width: 80px;
  max-height: 20px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background-color: white;
  padding: 0 8px 0 6px;
  gap: 6px;

  & svg {
    width: 10px;
    height: 10px;
  }
`;
export const keyboardInfo = styled.div`
  display: flex;
  border-radius: 2px;
  border: 0.4px solid #dddddd;
  padding: 1px 3px;
  align-items: center;
  justify-content: center;

  font-family: Arial, Helvetica, sans-serif;
  font-weight: normal;
  font-size: 10px;
  color: #888888;
`;

export const ToastsWrapper = styled.div`
  position: fixed;
  top: 40px;
  right: 0px;
  z-index: 20;
  overflow-y: auto;
  max-height: 100vh;
  font-family: Arial, Helvetica, sans-serif;

  &:has(div) {
    padding: 20px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    top: 70px;
  }
`;
